import {useEffect} from 'react'

type OnWindowScrollCb = () => void

function useWindowScroll(callback: OnWindowScrollCb): void {
  useEffect(() => {
    window.addEventListener('scroll', callback)

    return () => window.removeEventListener('scroll', callback)
  }, [])
}

export default useWindowScroll
